import { render } from "./YolaBranch.vue?vue&type=template&id=2a2c715f&scoped=true"
import script from "./YolaBranch.vue?vue&type=script&lang=js"
export * from "./YolaBranch.vue?vue&type=script&lang=js"

import "./YolaBranch.vue?vue&type=style&index=0&id=2a2c715f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2c715f"]])

export default __exports__